import { render, staticRenderFns } from "./KeyValuesList.vue?vue&type=template&id=2357ddbc"
import script from "./KeyValuesList.vue?vue&type=script&lang=js"
export * from "./KeyValuesList.vue?vue&type=script&lang=js"
import style0 from "./KeyValuesList.vue?vue&type=style&index=0&id=2357ddbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports